import React, { useState, useEffect } from 'react';
import { Select, message } from 'antd'
import CustomAvatar from "../Avatar/Avatar";
const { Option } = Select 
const axios = require("axios");

/**
 * @const Selectempleado
 * @description Select para las empleados registradas en el sistema
 */
const Selectempleado = (props) => {

    const { 
        value, 
        onChange, 
        placeholder = "Seleccione la empleado", 
        onSelect = () => {}, 
        disabled = false, 
        className = "", 
        params = {}, 
        bordered, 
        allowClear = true, 
        onClear = () => {},
        mode = null
    } = props

    const [ empleados, setEmpleados ] = useState({
        data: [],
        page: 1,
        limit: 10,
        total: 0,
        search: null,
    })


    /**
     * @const getempleados
     * @description Obitiene los empleados
     */
    const getEmpleados = ({page, limit, search} = empleados) => {

        axios.get('/empleados', {
            params: {
                page,
                limit,
                search,
                ...params,
            },
        }).then(({ data }) => {
            setEmpleados(data)
        }).catch(error => {
            console.log("ERR, error",error)
            message.error(error?.response?.data?.message ?? 'Error al obtener las empleados')
        })
    }

    //componentDidMount
    useEffect(() => {
        getEmpleados()
    }, [])

    useEffect(() => {
        if(value)
            onChange(value?.value ?? value)
    }, [value])

    return (
        <Select
            bordered={bordered}
            className={className}
            disabled={disabled}
            placeholder={placeholder}
            allowClear={allowClear}
            showSearch
            filterOption={false}
            labelInValue
            mode={mode}
            onSearch={(search)=> getEmpleados({search})}
            onSelect={(acreedor)=> {
                if(mode === null){
                    onChange(acreedor.value)
                    onSelect(acreedor.value)
                }
            }}
            onChange={(values)=>{
                if(mode === "multiple"){
                    let arr = values.map(e => e.value)
                    onChange(arr)
                    onSelect(arr)
                }
            }}
            value={value}
            onClear={()=>{
                onClear()
                onChange(undefined)
                onSelect(undefined)
            }}
        >
            {
                empleados?.data?.map(({ _id, nombre, segundo_nombre, apellido_materno, apellido_paterno, color, logo }) => <Option value={_id} key={_id}>
                    {nombre} {segundo_nombre} {apellido_paterno} {apellido_materno}
                </Option>)
            }
        </Select>
    );
}



export default Selectempleado;